import { BoundaryListener } from './model/BoundaryListener';
import { ProgramInfo } from './model/ProgramInfo';
import { Player } from '@quickplay/player-interface';

export class BoundaryListenerImpl implements BoundaryListener {
  constructor(
    private readonly player: Player,
    private readonly onProgramStart: (player: Player, metadata?: ProgramInfo) => void,
  ) {
    // no-op
  }

  boundaryChangeCallback(metadata?: ProgramInfo): void {
    this.onProgramStart(this.player, metadata);
  }
}
